
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetoashtavinayakurbania() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Urbania Tour Package',
        heading: 'Samarth Travels: Pune to Ashtavinayak Urbania Tour Package',
        headingDescription: 'Samarth Travels offers a comfortable Pune to Ashtavinayak Urbania tour package, perfect for spiritual journeys with family or groups. Travel in our luxury Force Urbania vans equipped with AC, push-back seats, and ample space. With experienced drivers, fixed itinerary options, and transparent pricing, Samarth Travels ensures a peaceful and well-organized pilgrimage to all eight Ganpati temples.',

        top: 'Top Places to Visit in Ashtavinayak with Samarth Travels',

        "topPlaces": [
    {
      "title": "Shri Mayureshwar Temple – Morgaon",
      "description": "Shri Mayureshwar Temple in Morgaon is the starting and ending point of the Ashtavinayak Yatra. It is the most significant of the eight temples and is considered the Adya Peeth (primary shrine) of Lord Ganesha. The temple is surrounded by a high stone wall with minarets and has a beautiful black stone idol of Ganesha seated on a peacock. The temple’s legend involves Lord Ganesha slaying the demon Sindhu, symbolizing victory over evil."
    },
    {
      "title": "Shri Siddhivinayak Temple – Siddhatek",
      "description": "Located on the banks of the Bhima River, Shri Siddhivinayak Temple in Siddhatek is known for fulfilling wishes and granting spiritual power (siddhis). The temple houses a swayambhu (self-originated) idol of Ganesha with the trunk turned to the right, which is considered highly sacred and powerful. It is believed that Lord Vishnu performed penance here to gain strength to defeat demons Madhu and Kaitabha."
    },
    {
      "title": "Shri Ballaleshwar Temple – Pali",
      "description": "Located in the Raigad district, Shri Ballaleshwar is the only Ganesha temple where the deity is known by the name of his devotee—Ballal. This temple represents pure devotion and is built in such a way that during the morning aarti, the sun's rays directly fall on the idol. The idol is flanked by Riddhi and Siddhi, representing prosperity and success, and the temple is known for its serene environment and unique architecture."
    },
    {
      "title": "Shri Varadvinayak Temple – Mahad",
      "description": "Situated in Mahad, near Khopoli, this temple is associated with the legend of Prince Rukmaganda and his devotion to Lord Ganesha. The idol here is swayambhu and immersed in an oil lamp, believed to have been burning continuously for years. Devotees are allowed to perform rituals themselves here, which is rare and adds to the spiritual experience of this temple."
    },
    {
      "title": "Shri Chintamani Temple – Theur",
      "description": "Located near Pune, the Shri Chintamani Temple in Theur is associated with the story of Ganesha retrieving the Chintamani jewel for sage Kapila and thus removing his worries (chinta). The temple is situated on the confluence of the Mula, Mutha, and Bhima rivers, and is known for its peaceful ambiance. It features a large hall supported by wooden pillars and a beautiful idol of Lord Ganesha bedecked in jewels."
    },
    {
      "title": "Shri Girijatmaj Temple – Lenyadri",
      "description": "This unique temple is carved into a mountain cave in the Lenyadri hills and is the only Ashtavinayak temple located in a Buddhist-style cave complex. It is believed to be the place where Goddess Parvati performed penance and Ganesha was born. Reached by climbing around 300 steps, the temple offers panoramic views of the surrounding landscape and features no separate idol; the image of Ganesha is carved directly into a rock wall."
    },
    {
      "title": "Shri Vighnahar Temple – Ozar",
      "description": "Located on the banks of the Kukadi River, Shri Vighnahar Temple is dedicated to the form of Ganesha who removes obstacles (Vighnas). According to legend, Ganesha defeated the demon Vighnasura here. The temple features a majestic entrance, deepstambha (lamp tower), and beautifully adorned sanctum. The temple is known for its serene environment and well-maintained surroundings, drawing devotees seeking relief from hardships."
    },
    {
      "title": "Shri Mahaganapati Temple – Ranjangaon",
      "description": "Shri Mahaganapati Temple in Ranjangaon houses a massive idol of Lord Ganesha in a seated posture with ten trunks and twenty arms, symbolizing strength and protection. According to myth, Lord Shiva worshipped this form of Ganesha before defeating the demon Tripurasura. Though the large idol is kept in an underground chamber, the visible idol in the sanctum is equally revered. The temple is beautifully constructed with stone and has an aura of grandeur and mysticism."
    }
  ],

"services": [
  {
    "name": "Rent Urbania Bus for Outstation Tours from Pune",
    "description": "Travel in style with Samarth Travels' Force Urbania bus for outstation tours from Pune. Whether it's a family trip or corporate outing, enjoy a smooth and comfortable journey to destinations like Shirdi, Lonavala, and beyond."
  },
  {
    "name": "Pune to Outstation Urbania Bus Hire Services",
    "description": "For seamless outstation travel, rent a luxurious Urbania bus for your trips from Pune. Our services include comfortable travel options to all major destinations with experienced drivers and modern amenities."
  },
  {
    "name": "Affordable Urbania Bus Rentals for Outstation Trips Pune",
    "description": "Samarth Travels offers affordable Urbania bus rental services for your outstation trips from Pune. With budget-friendly options without compromising on luxury and comfort, it’s the ideal choice for group travel."
  },
  {
    "name": "Rent Urbania Luxury Bus for Outstation Travel Pune",
    "description": "For long-distance travel from Pune, opt for a luxurious Urbania bus rental. Equipped with air-conditioning, comfortable seats, and onboard amenities, it ensures a relaxing journey to your outstation destination."
  },
  {
    "name": "Urbania Bus Hire for Long-Distance Travel from Pune",
    "description": "Take a long-distance journey with ease by renting a Force Urbania bus from Pune. Perfect for destinations like Goa, Mahabaleshwar, and other outstation locales, enjoy a premium ride with a spacious interior."
  },
  {
    "name": "Comfortable Urbania Bus Hire for Outstation Tours",
    "description": "Experience the comfort of an Urbania bus rental for outstation tours from Pune. With ample legroom, air-conditioning, and cozy seating, your group will travel in complete comfort on all outstation journeys."
  },
  {
    "name": "Luxury Urbania Bus Hire Pune for Outstation Trips",
    "description": "For a truly luxurious travel experience, hire a Force Urbania bus from Pune for outstation trips. Ideal for corporate travel, family vacations, and group tours, enjoy premium amenities and excellent service."
  },
  {
    "name": "Rent 32-Seater Urbania Bus for Outstation Trips Pune",
    "description": "Looking for a spacious, comfortable bus for your outstation trip? Rent a 32-seater Urbania bus for your journey from Pune. Ideal for medium to large groups, this bus ensures a comfortable and smooth ride."
  },
  {
    "name": "Urbania Bus Rental for Corporate Outstation Travel Pune",
    "description": "For corporate trips, conferences, or team outings, rent an Urbania bus for outstation travel from Pune. Experience comfort and luxury with a professional driver, making corporate travel efficient and hassle-free."
  },
  {
    "name": "Pune to Outstation Urbania Bus Hire for Family Trips",
    "description": "Enjoy a family trip to your favorite outstation destination with our Urbania bus rental services from Pune. Spacious interiors and family-friendly amenities make it the perfect choice for family vacations."
  }
],
"tableData": [
  ["Rent Urbania Bus for Outstation Tours from Pune", "Pune to Outstation Urbania Bus Hire Services"],
  ["Affordable Urbania Bus Rentals for Outstation Trips Pune", "Rent Urbania Luxury Bus for Outstation Travel Pune"],
  ["Urbania Bus Hire for Long-Distance Travel from Pune", "Comfortable Urbania Bus Hire for Outstation Tours"],
  ["Luxury Urbania Bus Hire Pune for Outstation Trips", "Rent 32-Seater Urbania Bus for Outstation Trips Pune"],
  ["Urbania Bus Rental for Corporate Outstation Travel Pune", "Pune to Outstation Urbania Bus Hire for Family Trips"]
],


    

"whychoose": [
    {
        "WhyChooseheading": "Pune to Ashtavinayak Urbania Tour Package – Divine Comfort",
        "WhyChoosedescription": "Samarth Travels offers a premium Urbania tour package from Pune to the Ashtavinayak temples. This is the perfect solution for families, groups, or devotees looking to experience the sacred pilgrimage in style, comfort, and utmost convenience. Our Force Urbania ensures a smooth and luxurious ride to all eight Ashtavinayak temples."
    },
    {
        "WhyChooseheading": "Spacious, Luxurious Interiors for a Peaceful Pilgrimage",
        "WhyChoosedescription": "Our Force Urbania features plush leather seating, ample legroom, air conditioning, individual reading lights, and USB charging ports, ensuring a comfortable and relaxing experience throughout your Ashtavinayak tour. Whether you're traveling for a day or over multiple days, your journey will be peaceful and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs for Safe and Reliable Travel",
        "WhyChoosedescription": "Each Urbania rental comes with a professional chauffeur who is familiar with the Ashtavinayak route and pilgrimage sites. Our drivers are punctual, courteous, and committed to providing a safe, smooth, and timely journey so you can focus on your spiritual experience."
    },
    {
        "WhyChooseheading": "Tailored for Devotees, Families, and Groups",
        "WhyChoosedescription": "Whether you're a large family, a group of friends, or a corporate team planning a spiritual retreat, our Urbania tour package offers a private, luxurious, and seamless way to visit the Ashtavinayak temples. We can customize your itinerary to fit your schedule and needs."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Sanitized Urbania Fleet",
        "WhyChoosedescription": "We ensure that all our Urbania vehicles are thoroughly cleaned, sanitized, and checked before every trip, offering you peace of mind throughout your Ashtavinayak pilgrimage. Our vehicles are maintained to the highest standards to ensure comfort and safety."
    },
    {
        "WhyChooseheading": "All-Inclusive Pricing with No Hidden Charges",
        "WhyChoosedescription": "Samarth Travels provides clear and competitive pricing for our Pune to Ashtavinayak Urbania tour package. The price covers all driver fees, fuel, tolls, and other charges—ensuring there are no surprises along the way."
    },
    {
        "WhyChooseheading": "Flexible Schedules and 24/7 Availability",
        "WhyChoosedescription": "We understand that your pilgrimage journey may require flexibility in terms of timing. That's why our Urbania buses are available 24/7, allowing you to start your Ashtavinayak tour whenever you prefer. We offer customized travel schedules to fit your needs."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Easy Booking",
        "WhyChoosedescription": "Booking your Pune to Ashtavinayak Urbania tour package is easy with Samarth Travels. We accept various payment options including UPI, credit/debit cards, digital wallets, and cash—making the process seamless and hassle-free."
    }
]


























    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Pune to Ashtavinayak Urbania tour package?',
        answer: 'Booking a Pune to Ashtavinayak Urbania tour package is simple with Samarth Travels. You can book online via our website or contact our customer support team. Provide details like your preferred travel dates, group size, and any special requirements, and we’ll customize the perfect package for your Ashtavinayak tour.',
    },
    {
        id: 2,
        question: 'What is included in the Pune to Ashtavinayak Urbania tour package?',
        answer: 'Our Pune to Ashtavinayak Urbania tour package includes the luxury Urbania vehicle, a professional driver, fuel charges, and all necessary permits for the Ashtavinayak pilgrimage. The tour package is designed to ensure comfort, safety, and convenience throughout the journey.',
    },
    {
        id: 3,
        question: 'What are the key features of the Urbania for the Ashtavinayak tour?',
        answer: 'The Force Urbania comes equipped with premium pushback seats, air-conditioning, USB charging ports, large windows for scenic views, reading lights, and ample luggage space. These features ensure that your journey to all eight Ashtavinayak temples is both luxurious and comfortable.',
    },
    {
        id: 4,
        question: 'How many people can travel in the Urbania for an Ashtavinayak tour?',
        answer: 'The Force Urbania is available in 10 to 17-seater configurations, making it ideal for family groups, corporate teams, or a group of friends traveling together for the Ashtavinayak pilgrimage.',
    },
    {
        id: 5,
        question: 'How long does the Pune to Ashtavinayak tour take?',
        answer: 'The Ashtavinayak tour from Pune typically takes 2 to 3 days, depending on your pace and the number of stops you make at each of the eight temples. We can customize the itinerary according to your preferences, ensuring you get the most out of this spiritual journey.',
    },
    {
        id: 6,
        question: 'Can the tour package be customized for specific requirements?',
        answer: 'Yes, we offer customization options for the Pune to Ashtavinayak tour package. Whether you need specific pickup locations, additional sightseeing, or extended duration, we can tailor the package to suit your preferences.',
    },
    {
        id: 7,
        question: 'What is the cost of the Pune to Ashtavinayak Urbania tour package?',
        answer: 'The cost of the Pune to Ashtavinayak Urbania tour package depends on factors like the number of passengers, duration, and any special requests. Our team will provide a transparent quote based on your requirements, ensuring there are no hidden charges.',
    },
];

const testimonials = [
    {
        name: 'Mr. Vinayak Jadhav',
        role: 'Business Executive',
        text: 'We booked the Urbania for a family Ashtavinayak tour from Pune. The vehicle was incredibly comfortable, and the driver ensured we had a smooth and peaceful journey. Samarth Travels made the trip memorable with their exceptional service!',
        image: '/img/testimonial/testi_2_64.jpg',
    },
    {
        name: 'Mrs. Manisha Deshmukh',
        role: 'Retired Teacher',
        text: 'The Urbania for our Ashtavinayak pilgrimage was a fantastic choice. Spacious, clean, and luxurious, it made the entire spiritual journey so much more enjoyable. The driver was very courteous and well-informed about the temples. Highly recommend Samarth Travels for such tours!',
        image: '/img/testimonial/testi_2_65.jpg',
    },
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Urbania Tour Package",
  "image": "https://samarthtravels.com/assets/images/pune-to-ashtavinayak-urbania-tour.jpg",
  "description": "Rent a Luxury Urbania Bus for Pune to Ashtavinayak pilgrimage tour. Affordable and comfortable rental options for family trips, group travel, and corporate packages to Ashtavinayak from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-ashtavinayak-urbania-tour-package"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Ashtavinayak Urbania Tour Package | Affordable & Luxury Bus Rentals | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Luxury Urbania Bus for Pune to Ashtavinayak pilgrimage tour. Affordable and comfortable rental options for family trips, group travel, and corporate packages to Ashtavinayak from Pune." 
  />
  <meta 
    name="keywords" 
    content="Rent Urbania Bus for Pune to Ashtavinayak Trip, Pune to Ashtavinayak Urbania Bus Package, Affordable Urbania Bus Hire for Ashtavinayak Tour, Luxury Urbania Bus Rental Pune to Ashtavinayak, Urbania Bus for Family Trip to Ashtavinayak from Pune, Pune to Ashtavinayak Urbania Bus Hire for Group Travel, Rent Urbania Bus for Pilgrimage Tour Pune to Ashtavinayak, Comfortable Urbania Bus Rental for Ashtavinayak Tour, Pune to Ashtavinayak Urbania Bus Hire Package Deal, Urbania Bus Rental for Corporate Group to Ashtavinayak" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakurbania;